import * as actionTypes from './actiontypes';
import states from './states';

const botparams_details = (state = states.botparams_details, action) => {
    switch (action.type) {
        case actionTypes.VARIABLES_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variables_loading: true,
                }
            }
        }

        case actionTypes.VARIABLES_LOADED: {
            return {
                ...state,
                variables: action.payload.variableDetail ? action.payload.variableDetail : [...state.variables],
                loaders: {
                    ...state.loaders,
                    variables_loading: false,
                    variables_load_error: false,
                }
            }
        }

        case actionTypes.VARIABLES_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variables_loading: false,
                    variables_load_error: true,
                }
            }
        }

        case actionTypes.VARIABLE_CREATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variable_creating: true,
                }
            }
        }

        case actionTypes.VARIABLE_CREATE_COMPLETE: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variable_creating: false,
                }
            }
        }

        case actionTypes.VARIABLE_CREATED: {
            return {
                ...state,
                variables: action.payload.variableDetail ? [action.payload.variableDetail, ...state.variables] : [...state.variables],
            }
        }

        case actionTypes.VARIABLE_UPDATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variable_updating: true,
                }
            }
        }

        case actionTypes.VARIABLE_UPDATE_COMPLETE: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    variable_updating: false,
                }
            }
        }

        case actionTypes.VARIABLE_UPDATED: {
            let index = -1;
            if (action.payload.variableDetail && action.payload.variableDetail._id) {
                index = state.variables.findIndex(variable => variable._id === action.payload.variableDetail._id);
            }
            return {
                ...state,
                variables: index !== -1 ? [...state.variables.slice(0, index), action.payload.variableDetail, ...state.variables.slice(index + 1)] : [...state.variables],
            }
        }

        case actionTypes.VARIABLE_DELETED: {
            let index = -1;
            if (action.payload.variableDetail && action.payload.variableDetail._id) {
                index = state.variables.findIndex(variable => variable._id === action.payload.variableDetail._id);
            }
            return {
                ...state,
                variables: index !== -1 ? [...state.variables.slice(0, index), ...state.variables.slice(index + 1)] : [...state.variables]
            }
        }

        case actionTypes.ACTIONS_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    actions_loading: true,
                }
            }
        }

        case actionTypes.ACTIONS_LOADED: {
            return {
                ...state,
                actions: action.payload.brandFunctionDetail ? action.payload.brandFunctionDetail : [...state.actions],
                loaders: {
                    ...state.loaders,
                    actions_loading: false,
                    actions_load_error: false,
                }
            }
        }

        case actionTypes.ACTIONS_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    actions_loading: false,
                    actions_load_error: true,
                }
            }
        }

        case actionTypes.ACTION_CREATED: {
            return {
                ...state,
                actions: action.payload.brandFunctionDetail ? [action.payload.brandFunctionDetail, ...state.actions] : [...state.actions],
            }
        }

        case actionTypes.ACTION_UPDATED: {
            let index = -1;
            if (action.payload.brandFunctionDetail && action.payload.brandFunctionDetail._id) {
                index = state.actions.findIndex(item => item._id === action.payload.brandFunctionDetail._id);
            }
            return {
                ...state,
                actions: index !== -1 ? [...state.actions.slice(0, index), action.payload.brandFunctionDetail, ...state.actions.slice(index + 1)] : [...state.actions],
            }
        }

        case actionTypes.ACTION_DELETED: {
            let index = -1;
            if (action.payload.brandFunctionDetail && action.payload.brandFunctionDetail._id) {
                index = state.actions.findIndex(item => item._id === action.payload.brandFunctionDetail._id);
            }
            return {
                ...state,
                actions: index !== -1 ? [...state.actions.slice(0, index), ...state.actions.slice(index + 1)] : [...state.actions]
            }
        }

        default:
            return state;
    }
}

export default botparams_details;



// WEBPACK FOOTER //
// ./src/data/redux/botparams_details/reducers.js